"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.openedWidth = void 0;
var _theme = require("../../../theme");
var openedWidth = 244;
exports.openedWidth = openedWidth;
var closedWidth = 60;
var linkBorderWidth = 5;
var linkHorizontalPadding = 5;
var useStyles = (0, _theme.makeStyles)(function (_ref) {
  var _ref$palette = _ref.palette,
    primary = _ref$palette.primary,
    secondary = _ref$palette.secondary,
    text = _ref$palette.text,
    background = _ref.background,
    typography = _ref.typography,
    shade = _ref.utils.shade,
    light = _ref.light,
    dark = _ref.dark;
  return {
    root: function root(props) {
      return {
        width: props.type === 'static' ? closedWidth : openedWidth,
        height: props.type === 'static' ? '100%' : 'calc(100% - 58px)',
        "float": 'left',
        color: secondary.contrastText,
        fontSize: 12,
        lineHeight: '17px',
        position: props.type === 'static' ? 'relative' : 'fixed',
        top: props.type === 'static' ? 0 : '58px',
        left: 0,
        fontFamily: typography.fontFamily,
        transition: 'width 0.3s, transform .2s ease-in-out',
        transform: props.type === 'static' ? 'none' : 'translateX(-100%)',
        zIndex: 1301
      };
    },
    mainWrapper: {
      height: '100%',
      position: 'absolute'
    },
    mainHolder: function mainHolder(props) {
      return {
        width: props.type === 'static' ? closedWidth : openedWidth,
        height: '100%',
        display: 'flex',
        position: 'relative',
        flexDirection: 'column',
        backgroundColor: props.theme === 'dark' ? dark.persistantSideBar.nav.backgroundColor : light.persistantSideBar.mainHolder.backgroundColor,
        transition: 'width 0.3s'
      };
    },
    rollup: function rollup(props) {
      return {
        width: openedWidth,
        transform: props.type === 'static' ? 'none' : 'translateX(0)'
      };
    },
    opened: function opened(props) {
      return {
        width: openedWidth,
        transform: props.type === 'static' ? 'none' : 'translateX(0)',
        '& a.active': {
          backgroundColor: 'unset'
        }
      };
    },
    logo: {
      height: '75px',
      overflow: 'hidden',
      textDecoration: 'none',
      position: 'relative',
      marginBottom: '14px',
      '& img': {
        height: '35px',
        width: 'auto',
        flexShrink: 1,
        flexGrow: 0,
        margin: '0 auto',
        color: '#fff'
      }
    },
    logoExpanded: {
      '& img': {
        height: '35px'
      }
    },
    logoHolder: {
      position: 'absolute',
      width: openedWidth,
      height: '100%',
      top: 25,
      left: 18,
      right: 26
    },
    content: {
      display: 'flex',
      overflowY: 'auto',
      flexGrow: 1,
      height: 1,
      overflow: 'hidden',
      flexDirection: 'column'
    },
    nav: function nav(props) {
      return {
        height: '100%',
        '& a.active': {
          backgroundColor: props.theme === 'dark' ? dark.persistantSideBar.nav.backgroundColor : light.persistantSideBar.nav.backgroundColor
        }
      };
    },
    link: {
      color: '#a7b8c6',
      padding: "8px ".concat(linkHorizontalPadding, "px"),
      borderLeftWidth: linkBorderWidth,
      borderLeftStyle: 'solid',
      borderLeftColor: 'transparent',
      whiteSpace: 'nowrap',
      '&:hover': {
        borderLeftColor: primary.main,
        color: secondary.contrastText
      }
    },
    toggleButton: {
      top: 64,
      right: -9,
      position: 'absolute',
      width: 18,
      height: 18,
      borderRadius: '50%',
      cursor: 'pointer',
      color: text.primary,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: 10,
      border: "1px solid ".concat(shade(text.primary, 1)),
      backgroundColor: 'black'
    },
    linkActive: {
      borderLeftColor: primary.main,
      color: 'black'
    },
    linkIcon: {
      width: closedWidth - (linkBorderWidth + linkHorizontalPadding),
      display: 'inline-block',
      textAlign: 'center'
    },
    tools: {
      textAlign: 'center',
      marginTop: 'auto'
    },
    item: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: 56,
      textTransform: 'uppercase'
    },
    icon: {
      fontSize: 20,
      lineHeight: '25px'
    },
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.15)',
      zIndex: 1000,
      opacity: 0,
      transform: 'scale(0)',
      transition: 'opacity .2s ease-in-out, transform .0s ease-in-out .2s'
    },
    openOverlay: {
      opacity: 1,
      transform: 'scale(1)',
      transition: 'opacity .2s ease-in-out, transform .0s ease-in-out .0s'
    }
  };
}, {
  name: 'Sidebar'
});
exports.useStyles = useStyles;